export default __webpack_public_path__ + "static/media/Birst.c2b952e2.png";